<app-breadcrumb *ngIf="!department" master="Administracja" parentName="Działy" name="Dodaj"></app-breadcrumb>
<div class="department-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="departmentForm">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!departmentForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane działu</h3>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa</mat-label>
                <input matInput placeholder="IT" formControlName="name" [required]="true">
                <mat-error *ngIf="departmentForm.get('name').hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <app-dict-departments fxFlex="100" label="Dział nadrzędny" [control]="parentDepartmentControl" [multiple]="false"></app-dict-departments>
            </div>

            <div fxLayout="row">
              <app-dict-users fxFlex="100" label="Przełożony" [control]="supervisorControl" [multiple]="false"></app-dict-users>
            </div>

          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!departmentForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
